export const STORAGE_DISCLAIMER_VERSION_KEY = 'disclaimer_version';
export const STORAGE_CURRENT_DISCLAIMER_VERSION = 1;
